//=require svg4everybody/dist/svg4everybody.js

svg4everybody();
